import moment from 'moment';
import { combineReducers } from 'redux';
import leftSidebarReducer, * as leftSidebarReducerContent from './LeftSidebarContent/reducers';
import * as mapActionConstant from './Map/actions';
import * as leftsidebarActionConst from './LeftSidebarContent/actions';
import mapReducer, * as mapReducerContent from './Map/reducers';
import popUpDetailsReducer from './PopUpDetailsContent/reducers';
import * as constants from './actions';

const filterType = (state = 'monthly', action) => {
  switch (action.type) {
    case constants.CHANGE_FILTER_TYPE:
      return action.payload;
    default:
      return state;
  }
};

const filteringDateRange = (
  state = moment(new Date(), 'YYYY/MM/DD'),
  action
) => {
  switch (action.type) {
    case constants.CHANGE_DATE_RANGE:
      return action.payload;
    default:
      return state;
  }
};

const helpPopUpStatus = (state = false, action) => {
  switch (action.type) {
    case constants.CHANGE_HELP_POPUP_STATE:
      return action.payload;
    default:
      return state;
  }
};

const mapLoadingState = (state = false, action) => {
  switch (action.type) {
    case leftsidebarActionConst.FETCH_CB_COUNTRY_DETAILS_REQUEST:
    case leftsidebarActionConst.FETCH_CB_CLUSTER_DETAILS_REQUEST:
    case leftsidebarActionConst.FETCH_CB_AREA_DETAILS_REQUEST:
    case leftsidebarActionConst.FETCH_CB_THANA_DETAILS_REQUEST:
    case mapActionConstant.FETCH_COUNTRY_CKU_MAP_BY_ID_REQUEST:
    case mapActionConstant.FETCH_CB_CLUSTER_MAP_BY_ID_REQUEST:
    case mapActionConstant.FETCH_CB_AREA_MAP_BY_ID_REQUEST:
    case mapActionConstant.FETCH_CB_THANA_MAP_BY_ID_REQUEST:
      return true;
    case mapActionConstant.FETCH_COUNTRY_CKU_MAP_BY_ID_SUCCESS:
    case mapActionConstant.FETCH_CB_CLUSTER_MAP_BY_ID_SUCCESS:
    case mapActionConstant.FETCH_CB_AREA_MAP_BY_ID_SUCCESS:
    case mapActionConstant.FETCH_CB_THANA_MAP_BY_ID_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  leftSidebar: leftSidebarReducer,
  map: mapReducer,
  mapLoadingState,
  filterType,
  filteringDateRange,
  popUpDetails: popUpDetailsReducer,
  helpPopUpStatus: helpPopUpStatus
});

export const COUNTRY = leftSidebarReducerContent.COUNTRY;
export const CLUSTER = leftSidebarReducerContent.CLUSTER;
export const AREA = leftSidebarReducerContent.AREA;
export const THANA = leftSidebarReducerContent.THANA;

export const getCbCountryDetails = state =>
  leftSidebarReducerContent.getCbCountryDetails(state);

export const getCbClusterDetails = state =>
  leftSidebarReducerContent.getCbClusterDetails(state);

export const getCbAreaDetails = state =>
  leftSidebarReducerContent.getCbAreaDetails(state);

export const getCbThanaDetails = state =>
  leftSidebarReducerContent.getCbThanaDetails(state);

export const getSelectedState = state =>
  leftSidebarReducerContent.getSelectedState(state);

export const getFilteringState = state =>
  leftSidebarReducerContent.getFilteringState(state);

export const getMapLoadingState = state => {
  return state.user.cku.mapLoadingState;
};

export const getFilterType = state => {
  return state.user.cku.filterType;
};

export const getFilteringDateRange = state => {
  return state.user.cku.filteringDateRange;
};

export const getPartners = state => {
  return mapReducerContent.getPartners(state);
};

export const getPartnersWithTransaction = state => {
  return mapReducerContent.getPartnersWithTransaction(state);
};

export function getHelpPopUpStatus(state) {
  return state.user.cku.helpPopUpStatus;
}
